"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CompositionTemplateEnum = exports.Actor = exports.Kind = exports.ChatSide = void 0;
var ChatSide;
(function (ChatSide) {
    ChatSide["START"] = "chat-start";
    ChatSide["END"] = "chat-end";
})(ChatSide || (exports.ChatSide = ChatSide = {}));
var Kind;
(function (Kind) {
    Kind[Kind["NULL"] = 0] = "NULL";
    Kind[Kind["ChatText"] = 1] = "ChatText";
    Kind[Kind["ChatAsset"] = 2] = "ChatAsset";
    Kind[Kind["ChatArtifactPreview"] = 3] = "ChatArtifactPreview";
    Kind[Kind["ChatTable"] = 4] = "ChatTable";
    Kind[Kind["InputText"] = 101] = "InputText";
    Kind[Kind["InputChoice"] = 102] = "InputChoice";
    Kind[Kind["InputSlider"] = 103] = "InputSlider";
    Kind[Kind["InputCarousel"] = 104] = "InputCarousel";
    Kind[Kind["InputTimePicker"] = 105] = "InputTimePicker";
    Kind[Kind["InputContactsPicker"] = 106] = "InputContactsPicker";
    Kind[Kind["InputButton"] = 107] = "InputButton";
    Kind[Kind["InputSignature"] = 108] = "InputSignature";
    Kind[Kind["InputMediaPicker"] = 109] = "InputMediaPicker";
    Kind[Kind["InputSingleChoice"] = 110] = "InputSingleChoice";
    Kind[Kind["InputMultipleChoice"] = 111] = "InputMultipleChoice";
    Kind[Kind["InputDatePicker"] = 112] = "InputDatePicker";
    Kind[Kind["InputActivityPlan"] = 113] = "InputActivityPlan";
    Kind[Kind["InputArtifact"] = 114] = "InputArtifact";
    Kind[Kind["SideEffectNavigate"] = 400] = "SideEffectNavigate";
    Kind[Kind["Loop"] = 1001] = "Loop";
})(Kind || (exports.Kind = Kind = {}));
var Actor;
(function (Actor) {
    Actor[Actor["NULL"] = 0] = "NULL";
    Actor[Actor["Bot"] = 1] = "Bot";
    Actor[Actor["User"] = 2] = "User";
    Actor[Actor["Clinician"] = 3] = "Clinician";
    Actor[Actor["System"] = 4] = "System";
})(Actor || (exports.Actor = Actor = {}));
exports.CompositionTemplateEnum = {
    BINGE_EATING_MY_PLAN: 'BINGE_EATING_MY_PLAN',
    EATING_COMMITMENT: 'EATING_COMMITMENT',
    EATING_SCHEDULE: 'EATING_SCHEDULE',
    MYSTORYMYPLAN_CLINICAL: 'MYSTORYMYPLAN_CLINICAL',
    MYSTORYMYPLAN: 'MYSTORYMYPLAN',
    SCREENER_CSSRS: 'SCREENER_CSSRS',
    SCREENER_NUMERIC: 'SCREENER_NUMERIC',
    STRESS_SENSITIVITY_ASSESSMENT: 'STRESS_SENSITIVITY_ASSESSMENT',
    TEST: 'TEST',
    YST_MENTAL_HEALTH_CONCERNS: 'YST_MENTAL_HEALTH_CONCERNS',
};
//# sourceMappingURL=enums.js.map